export default "__VITE_ASSET__COdAmvIM__"